import { ActivatedRoute, Router } from "@angular/router";
import { ApiService } from "./api.service";
var PracticeReportComponent = (function () {
    function PracticeReportComponent(route, router, apiService) {
        this.route = route;
        this.router = router;
        this.apiService = apiService;
    }
    PracticeReportComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isSeperateModel = 0;
        this.sub = this.route.params.subscribe(function (params) {
            _this.practiceId = params['practiceId'];
            _this.reportType = params['reportType'];
            _this.caseId = params['caseId'];
            _this.isSeperateModel = params['isSeperateModel'];
            _this.firstEntry = params['firstEntry'];
            _this.learningPathId = params['learningPathId'];
            _this.getReport();
            if (_this.reportType == "exercise") {
                _this.page = "bigReport";
            }
            else {
                _this.page = "smallReport";
            }
        });
    };
    PracticeReportComponent.prototype.getReport = function () {
        var _this = this;
        this.apiService.getPracticeReport("" + this.practiceId + "").subscribe(function (report) {
            _this.report = report;
            _this.practiceMetaId = report.practiceMetaId;
            if (_this.caseId <= 0) {
                _this.currentReportIndex = 0;
            }
            else {
                for (var i = 0; i < report.reports.length; i++) {
                    if (report.reports[i].id == _this.caseId
                        && report.reports[i].type == _this.reportType) {
                        _this.currentReportIndex = i;
                        break;
                    }
                }
            }
        });
        /*this.report=this.getMockReport();
        this.currentReportIndex = 3;*/
    };
    PracticeReportComponent.prototype.startNextCase = function () {
        var _this = this;
        this.apiService.startNextCase("" + this.practiceId + "").subscribe(function (result) {
            if (result.learningPathId > 0) {
                var link = ['case-practice', result.learningPathId, result.practiceId];
                _this.router.navigate(link);
            }
            else {
                var link = [result.practiceMetaId, 'case-practice'];
                _this.router.navigate(link);
            }
        });
    };
    PracticeReportComponent.prototype.switchReport = function (param) {
        window.scrollTo(0, 0);
        //document.documentElement.scrollTop = 0;
        //this.moveOut();
        this.page = param.type == "exercise" ? "bigReport" : "smallReport";
        this.currentReportIndex = param.index;
        //this.moveIn();
    };
    PracticeReportComponent.prototype.moveOut = function () {
        document.getElementById("reportWrap").style.transform = "translate(7.7rem,0)";
    };
    PracticeReportComponent.prototype.moveIn = function () {
        document.getElementById("reportWrap").style.transform = "translate(0,0)";
    };
    PracticeReportComponent.prototype.exit = function (param) {
        var _this = this;
        if (this.isSeperateModel == 1) {
            wx.closeWindow();
        }
        else {
            this.apiService.ajax({
                'type': 'get',
                'url': '/ddilearner/v1/getLearningPathMetaId/' + this.learningPathId
            }).subscribe(function (result) {
                var link = ['learning-path', result.data];
                _this.router.navigate(link);
            });
        }
    };
    PracticeReportComponent.prototype.getMockReport = function () {
        return {
            id: 1,
            reports: [{
                    id: 1,
                    name: "巩固练习1",
                    description: "在这次的巩固练习中，我们主要练习了促进参与和达成共识这两个关键行动。",
                    type: "quiz"
                }, {
                    id: 2,
                    name: "巩固练习2",
                    description: "在这次的巩固练习中，我们主要练习了促进参与和达成共识这两个关键行动。",
                    type: "quiz"
                }, {
                    id: 1,
                    name: "情景模拟1",
                    type: "exercise",
                    kas: [{
                            name: "说明讨论的目的",
                            value: "2"
                        }, {
                            name: "澄清绩效",
                            value: "3"
                        }, {
                            name: "表达绩效期望",
                            value: "4"
                        }, {
                            name: "维持动力",
                            value: "2"
                        }, {
                            name: "提供支持",
                            value: "4"
                        }, {
                            name: "达成共识",
                            value: "3"
                        }, {
                            name: "制定行动计划",
                            value: "1"
                        }],
                    totalKa: 19
                }, {
                    id: 2,
                    name: "情景模拟2",
                    type: "exercise",
                    kas: [{
                            name: "说明讨论的目的",
                            value: "3"
                        }, {
                            name: "澄清绩效",
                            value: "2"
                        }, {
                            name: "表达绩效期望",
                            value: "4"
                        }, {
                            name: "维持动力",
                            value: "4"
                        }, {
                            name: "提供支持",
                            value: "2"
                        }, {
                            name: "达成共识",
                            value: "5"
                        }, {
                            name: "制定行动计划",
                            value: "2"
                        }],
                    totalKa: 22
                }],
            totalQuizCount: 2,
            allQuizFinished: true,
            finishedQuizCount: 2,
            totalExerciseCount: 3,
            allExerciseFinished: false,
            finishedExerciseCount: 2,
            nextExerciseStartTime: "12月17日早上8点"
        };
    };
    return PracticeReportComponent;
}());
export { PracticeReportComponent };



// WEBPACK FOOTER //
// ./src/app/practice-report.component.ts.pre-build-optimizer.js